// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/transact-preview/editor.scss
// module id = 8
// module chunks = 0